// extracted by mini-css-extract-plugin
export default {"smartHeader":"style_smartHeader__1CRk6","smartHeaderAvatar":"style_smartHeaderAvatar__ioJ7h"};